import 'css-chunksrc/client/pages/projectPage/resourcesPage/filters/sortDropDown/dropDownList/styles.scss';export default {
  "dropDownList": "_dropDownList_1qwnf_1",
  "element": "_element_1qwnf_9",
  "selected": "_selected_1qwnf_17"
};